import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "~/locales/en.json";
import fr from "~/locales/fr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
  });

export const getI18nLanguageFromISOLanguage = (isoLanguage: string) => {
  const language = isoLanguage.substring(0, 2);
  return language === "fr" ? "fr" : "en";
};

export const getI18nLanguageFullFromISOLanguage = (isoLanguage: string) => {
  const language = isoLanguage.substring(0, 2);
  return language === "fr" ? "french" : "english";
};

export default i18n;
